import { dateObjToStr2 } from '@/utils/common'
import { msg } from '@/utils/index'
import { getEditMaindata } from '@/api/goodStand'
export default {
  data() {
    return {
      userTypeOpts: [
        { label: '4', text: '医疗卫生机构' },
        { label: '5', text: '药品经营企业' },
        { label: '6', text: '药品生产企业' },
        { label: '69', text: '服务商' }
      ],
      yingyeInfo1: [], // 营业表格左右的数据
      yingyeInfo2: [],
      yingyeOpts: {
        is_yibao: [
          { label: '是', text: '是' },
          { label: '否', text: '否' }
        ],
        busi_mode: [ // 经营方式
          { value: '个体工商户', text: '个体工商户' }, { value: '其他', text: '其他' },
          { value: '分支机构', text: '分支机构' }, { value: '单体', text: '单体' }, { value: '单体门店', text: '单体门店' },
          { value: '单体零售', text: '单体零售' }, { value: '单体零售企业', text: '单体零售企业' }, { value: '或其他单体零售企业', text: '或其他单体零售企业' },
          { value: '批发', text: '批发' }, { value: '批发(非法人)', text: '批发(非法人)' }, { value: '批发(法人)', text: '批发(法人)' },
          { value: '批发企业', text: '批发企业' }, { value: '批发兼零售', text: '批发兼零售' }, { value: '批发或分支机构', text: '批发或分支机构' },
          { value: '有限责任', text: '有限责任' }, { value: '法人', text: '法人' }, { value: '法人批发企业', text: '法人批发企业' },
          { value: '生物制品 (含疫苗) 的批发', text: '生物制品 (含疫苗) 的批发' }, { value: '第三方药品物流', text: '第三方药品物流' },
          { value: '药品批发', text: '药品批发' }, { value: '药品批发企业', text: '药品批发企业' },
          { value: '药品经营企业-零售连锁', text: '药品经营企业-零售连锁' }, { value: '药品零售', text: '药品零售' }, { value: '连锁', text: '连锁' },
          { value: '连锁 (总部)', text: '连锁 (总部)' }, { value: '连锁公司', text: '连锁公司' }, { value: '连锁加盟', text: '连锁加盟' },
          { value: '连锁直营', text: '连锁直营' }, { value: '连锁门店', text: '连锁门店' }, { value: '零售', text: '零售' },
          { value: '零售 (连锁)', text: '零售 (连锁)' }, { value: '零售单体', text: '零售单体' }, { value: '零售法', text: '零售法' }, { value: '零售连锁', text: '零售连锁' },
          { value: '零售连锁 (经营处方药和非处方药)', text: '零售连锁 (经营处方药和非处方药)' }, { value: '零售连锁企业', text: '零售连锁企业' },
          { value: '零售连锁分店', text: '零售连锁分店' }, { value: '零售连锁总部', text: '零售连锁总部' }, { value: '零售连锁门店', text: '零售连锁门店' },
          { value: '零售 (二级)', text: '零售 (二级)' }, { value: '零售 (单体)', text: '零售 (单体)' }, { value: '零售 (连锁)', text: '零售 (连锁)' },
          { value: '非法人', text: '非法人' }, { value: '非法人批发公司', text: '非法人批发公司' }
        ],
        is_junqu: [
          { label: '是', text: '是' },
          { label: '否', text: '否' }
        ]
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.hasPagePermission()
        if (route.params.type === 'kehuData') { // 客户主数据库
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' }
          ]
        } else if (route.params.type === 'companyData') { // 生产企业数据库
          this.userTypeOpts = [
            { label: '6', text: '药品生产企业' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '生产范围', field: 'busi_range', value: '', type: 'input' },
            { label: '公司传真', field: 'fax', value: '', type: 'input' },
            { label: '分类码', field: 'cat_code', value: '', type: 'input' },
            { label: '法定代表人', field: 'busi_legal', value: '', type: 'input' },
            { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
            { label: '质量负责人', field: 'qa_person', value: '', type: 'input' },
            { label: '签发人', field: 'sign_person', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' },
            { label: '官网地址', field: 'website', value: '', type: 'input' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '药品生产许可证编号', field: 'license_num', value: '', type: 'input' },
            { label: '日常监督机构', field: 'regulator', value: '', type: 'input' },
            { label: '日常监管人员', field: 'supervisors', value: '', type: 'input' },
            { label: '监督举报电话', field: 'supervisor_tel', value: '', type: 'input' },
            { label: '发证机关', field: 'issued', value: '', type: 'input' },
            { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
            { label: '生产地址', field: 'prod_addr', value: '', type: 'textarea' }
          ]
        } else if (route.params.type === 'shangyeData') { // 中国商业数据库
          this.userTypeOpts = [
            { label: '5', text: '药品经营企业' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '许可证编号', field: 'license_num', value: '', type: 'input' },
            { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
            { label: '仓库地址', field: 'store_address', value: '', type: 'textarea' },
            { label: '法人代表', field: 'busi_legal', value: '', type: 'input' },
            { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
            { label: '质量负责人', field: 'qa_person', value: '', type: 'input' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '经营方式', field: 'busi_mode', value: '', type: 'select' },
            { label: '发证机构', field: 'issued', value: '', type: 'input' },
            { label: '相关数据查询', field: 'about_db', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
        } else if (route.params.type === 'yiliaoData') { // 中国医疗机构库
          this.userTypeOpts = [
            { label: '4', text: '医疗卫生机构' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '负责人', field: 'busi_man', value: '', type: 'input' },
            { label: '邮编', field: 'post', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '邮箱', field: 'email', value: '', type: 'input' },
            { label: '诊疗项目', field: 'diag_item', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' }
          ]
          this.baseInfoOpt = [
            { label: '是否军区', field: 'is_junqu', value: '', type: 'select' },
            { label: '医院科室', field: 'departments', value: '', type: 'input' },
            { label: '员工数', field: 'doctors', value: '', type: 'input' },
            { label: '医院设备', field: 'hos_device', value: '', type: 'input' },
            { label: '床位数', field: 'bed_count', value: '', type: 'input' },
            { label: '门诊量(日)', field: 'outpatient', value: '', type: 'input' }
          ]
        } else if (route.params.type === 'yaodianData') { // 中国药店数据库
          this.userTypeOpts = [
            { label: '5', text: '药品经营企业' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '许可证号', field: 'license_num', value: '', type: 'input' },
            { label: '企业法人', field: 'busi_legal', value: '', type: 'input' },
            { label: '企业负责人', field: 'busi_man', value: '', type: 'input' },
            { label: '经营方式', field: 'busi_mode', value: '', type: 'input' },
            { label: '注册地址', field: 'reg_addr', value: '', type: 'textarea' },
            // { label: '仓库地址', field: 'store_address', value: '', type: 'textarea' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '相关数据查询', field: 'about_db', value: '', type: 'input' },
            { label: '质量负责人', field: 'qa_person', value: '', type: 'input' },
            { label: '发证/审批机关', field: 'issued', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' },
            { label: '仓库地址', field: 'store_address', value: '', type: 'textarea' }
          ]
        } else if (route.params.type === 'yiyuanData') { // 中国医院数据路
          this.userTypeOpts = [
            { label: '4', text: '医疗卫生机构' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '是否医保', field: 'is_yibao', value: '', type: 'radio' },
            { label: '负责人', field: 'busi_man', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '邮编', field: 'post', value: '', type: 'input' },
            { label: '诊疗项目', field: 'diag_item', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' }
          ]
          this.baseInfoOpt = [
            { label: '是否军区', field: 'is_junqu', value: '', type: 'select' },
            { label: '科室数量', field: 'ks_count', value: '', type: 'number' },
            { label: '重点科室', field: 'departments', value: '', type: 'input' },
            { label: '医生数量', field: 'doctors', value: '', type: 'number' },
            { label: '医院设备', field: 'hos_device', value: '', type: 'input' },
            { label: '床位数', field: 'bed_count', value: '', type: 'input' },
            { label: '门诊量(日)', field: 'outpatient', value: '', type: 'input' }
          ]
        } else if (route.params.type === 'zhongduanData') { // 第三终端数据库
          this.userTypeOpts = [
            { label: '4', text: '医疗卫生机构' }
          ]
          this.yingyeInfo1 = [
            { label: '营业执照', field: 'business_licence', value: '', type: 'input' },
            { label: '成立日期', field: 'estab_date', value: '', type: 'date' },
            { label: '经营范围', field: 'busi_range', value: '', type: 'input' },
            { label: '传真号码', field: 'fax', value: '', type: 'input' },
            { label: '公司简介', field: 'hos_syno', value: '', type: 'textarea' }
          ]
          this.yingyeInfo2 = [
            { label: '经营状态', field: 'operate_status', value: '', type: 'input' },
            { label: '营业期限', field: '', value: '', type: 'daterange',
              child: [
                { field: 'business_start_date', value: '' },
                { field: 'business_end_date', value: '' }
              ]
            },
            { label: '联系电话', field: 'tel', value: '', type: 'input' },
            { label: '邮编', field: 'post', value: '', type: 'input' },
            { label: '官网地址', field: 'website', value: '', type: 'input' }
          ]
        }
        // 新增-手动选择终端分类的值
        if (this.$route.name === 'addData') {
          this.libForm.userType = this.userTypeOpts[0].label
        // 获取编辑的值
        } else if (route.name === 'editData') {
          this.getEditData()
        }
      },
      immediate: true
    },
    'libForm.userType': {
      //  监听终端分类 切换终端类型的选项值和终端类别的选项值
      handler(val) {
        if (val === '4') {
          // 终端分类 是医疗卫生机构
          this.typeOpts = [
            { text: '医院', value: '11' },
            { text: '基层医疗卫生机构', value: '12' },
            { text: '专业公共卫生机构', value: '13' },
            { text: '其他医疗卫生机构', value: '14' },
            { text: '为空', value: '0' }
          ]
          this.classOpts = {
            11: [
              { value: '29', text: '综合医院' },
              { value: '30', text: '中医医院' },
              { value: '31', text: '专科医院' },
              { value: '32', text: '中西医结合医院' },
              { value: '33', text: '民族医院' },
              { value: '34', text: '护理院' },
              { value: '0', text: '为空' }
            ],
            12: [
              { value: '35', text: '社区卫生服务中心' },
              { value: '36', text: '社区卫生服务站' },
              { value: '37', text: '街道卫生院' },
              { value: '38', text: '乡镇卫生院' },
              { value: '39', text: '村卫生室' },
              { value: '40', text: '门诊部(所)' },
              { value: '41', text: '诊所(医务室、护理站)' },
              { value: '0', text: '为空' }
            ],
            13: [
              { value: '42', text: '疾病预防防护中心' },
              { value: '43', text: '专科疾病防治院(所/站)' },
              { value: '44', text: '健康教育所(站)' },
              { value: '45', text: '妇幼保健院(所/站)' },
              { value: '46', text: '急救中心(站)' },
              { value: '47', text: '卫生监督所(中心)' },
              { value: '48', text: '计划生育技术服务机构' },
              { value: '0', text: '为空' }
            ],
            14: [
              { value: '49', text: '疗养院' },
              { value: '50', text: '医学科研机构' },
              { value: '51', text: '医学在职培训机构' },
              { value: '52', text: '统计信息中心' },
              { value: '53', text: '其他' },
              { value: '0', text: '为空' }
            ],
            0: [
              { value: '0', text: '为空' }
            ]
          }
        }
        if (val === '5') {
          // 终端分类 是药品经营企业
          this.typeOpts = [
            { text: '药品批发企业', value: '15' },
            { text: '药品零售企业', value: '16' },
            { text: '为空', value: '0' }
          ]
          this.classOpts = {
            0: [
              { value: '0', text: '为空' }
            ],
            15: [
              { value: '54', text: '商业公司' },
              { value: '0', text: '为空' }
            ],
            16: [
              { value: '55', text: '零售连锁' },
              { value: '56', text: '连锁门店' },
              { value: '57', text: '单体药店' },
              { value: '0', text: '为空' }
            ]
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // 当前新增或者编辑页是不是有权限
    hasPagePermission() {
      const pagePermission = { // 编辑和新增页权限
        'kehuData': '客户主数据库',
        'companyData': '生产企业数据库',
        'shangyeData': '中国商业数据库',
        'yiliaoData': '中国医疗机构库',
        'yaodianData': '中国药店数据库',
        'yiyuanData': '中国医院数据库',
        'zhongduanData': '第三终端数据库'
      }
      const permissionList = this.$store.state.user.roles.map(item => item.name)
      const curList = pagePermission[this.$route.params.type]
      if (!permissionList.includes(curList)) {
        this.$router.push({
          path: '/404'
        })
      }
    },
    // 提交的参数
    getParams() {
      const baseParams = {
        name: this.libForm.name, // 名称
        history_name: this.libForm.history_name, // 曾用名
        alias_name: this.libForm.alias_name.map(item => item.name), // 别名
        source: this.libForm.source, // 来源
        org_type_2: this.libForm.userType, // 终端分类
        org_type_3: this.libForm.type, // 终端类型
        org_type_4: this.libForm.class, // 终端类别
        reg_type_1: this.libForm.xingzhi, // 经营性质
        reg_type_2: this.libForm.suoyouzhi, // 所有制形式
        dj: this.libForm.yaojuhui, // 药聚汇等级
        is_junqu: this.libForm.junqu, // 是否军区
        le_type_2: this.libForm.dingji, // 定级
        le_type_3: this.libForm.dingdeng // 定等
      }
      const baseInfoParams = {}
      if (this.baseInfoOpt.length) {
        this.baseInfoOpt.forEach(item => {
          baseInfoParams[item.field] = item.value
        })
      }
      const yiParams = {}
      let betweenValid = false
      this.yingyeInfo1.concat(this.yingyeInfo2).map(item => {
        if (item.type === 'daterange') {
          if (Number(item.child[0].value) !== 0 && Number(item.child[1].value) !== 0 && Number(item.child[0].value) > Number(item.child[1].value)) {
            betweenValid = true
          }
          yiParams[item.child[0].field] = dateObjToStr2(item.child[0].value)
          yiParams[item.child[1].field] = dateObjToStr2(item.child[1].value)
        } else if (item.type === 'date') {
          yiParams[item.field] = dateObjToStr2(item.value)
        } else {
          yiParams[item.field] = item.value
        }
      })
      if (betweenValid) {
        msg.call(this, '开始时间不能大于结束时间')
      }
      const addParams = {
        p_name: this.libForm.p_name, // 省
        city_name: this.libForm.city_name, // 市
        ad_name: this.libForm.ad_name, // 区 县
        address: this.libForm.address, // 地址
        location_jingdu: this.libForm.location_jingdu, // 经度
        location_weidu: this.libForm.location_weidu // 纬度
      }
      this.$emit('submit', Object.assign({}, baseParams, baseInfoParams, yiParams, addParams))
    },
    // 获取编辑数据
    getEditData() {
      this.loading = true
      getEditMaindata(this.$route.params.id, this.$route.params.type).then(res => {
        this.loading = false
        if (res.code === 0) {
          const { info } = res.result
          this.libForm.name = info.name
          this.libForm.history_name = info.history_name
          this.libForm.source = info.source
          // 曾用名 处理曾用名 和对应的曾用名错误
          this.libForm.alias_name = info.alias_name.split(',/,').map(item => {
            return { name: item }
          })
          this.libFormErr.alias_name = info.alias_name.split(',/,').map(item => {
            return { error: '' }
          })
          this.libForm.userType = info.org_type_2
          this.libForm.type = info.org_type_3
          this.libForm.class = info.org_type_4
          this.libForm.xingzhi = info.reg_type_1
          this.libForm.suoyouzhi = info.reg_type_2
          this.libForm.yaojuhui = info.dj
          this.libForm.junqu = info.is_junqu
          this.libForm.weijiwei = info.wjw_dj
          this.libForm.weiyi = info.weiyi_dj
          this.libForm.chunyu = info.chunyu_dj
          this.libForm.haodaifu = info.haodaifu_dj
          this.libForm.dingji = info.le_type_2
          this.libForm.dingdeng = info.le_type_3
          // 地址信息
          this.libForm.p_name = info.p_name
          this.libForm.city_name = info.city_name
          this.libForm.ad_name = info.ad_name
          this.libForm.address = info.address
          this.libForm.location_jingdu = info.location_jingdu
          this.libForm.location_weidu = info.location_weidu
          this.baseInfoOpt.forEach(item => {
            item.value = info[item.field]
          })
          // 营业信息
          this.yingyeInfo1.forEach(item => {
            if (item.type === 'daterange') {
              item.child.forEach(subItem => {
                subItem.value = info[subItem.field]
              })
            } else {
              item.value = info[item.field]
            }
          })
          this.yingyeInfo2.forEach(item => {
            if (item.type === 'daterange') {
              item.child.forEach(subItem => {
                subItem.value = info[subItem.field]
              })
            } else {
              item.value = info[item.field]
            }
          })
          this.addMark({
            lng: info.location_jingdu,
            lat: info.location_weidu
          })
        } else {
          msg.call(this, res.msg)
        }
      })
    }
  }
}
